<template>
<div>
         
  <!-- <generic-view
    id="packages_container"
    title="Packages"
    entity_name="package"
    :headers="headers"
    :user_id="user_id"
    :driver_id="driver_id"
    :localizable_fields="localizableFields"
  >
  </generic-view> -->
  
  <generic-view
    v-if="showTables"
    id="waybills_container"
    title="Approved Waybills"
    entity_name="wayBill"
    :headers="waybillHeaders"
    :user_id="user_id"
    :driver_id="driver_id"
    :show_excel="true"
    :show_print="true"
    :isActive="true"
    :showCardView="true"
    :hideAddButton="hideAddButton"
    @entity_posted="reloadData"
    fullscreen
    shareable
    icon="mdi-file-check-outline"
  >
  </generic-view>

  <!--<generic-view
    v-if="showTables"
    id="waybills_container2"
    title="Pending Waybills"
    entity_name="pending_wayBill"
    :headers="waybillHeaders"
    :user_id="user_id"
    :driver_id="driver_id"
    :isActive="false"
    @entity_posted="reloadData"
    fullscreen
    icon="mdi-file-question-outline"
  >
  </generic-view>
-->
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import WaybillHeaders from '../mixins/waybillHeaders'
export default {
  props:['user_id','driver_id'], //the phone might belong to a user or a driver
  mixins:[ WaybillHeaders ],
  data(){
      return {
        showTables:true,
        hideAddButton:false
      }
  },
  computed:{
    ...mapState('users',['user']),
    headers(){
      return [
                {
                    text:"Package Identifier",
                    value:"identifier",
                    type:'textfield'
                },
                {
                    text:"User",
                    value:"userId",
                    type:'autocomplete',
                    entity:'user',
                    hide_client:true
                },
                {
                  text: 'QR Or Bar Code',
                  value: 'qrCode',
                  type:'qr_code',
                  media:'qrCodeMedia',
                  media_id:'qrCodeMediaId',
                  media_type:5
                },
                {
                  text: 'QR Or Bar Code Manual Entry',
                  value: 'qrCode',
                  type:'textfield',
                },
            ]
      },
      localizableFields(){
          return [
            {
                text:'Name',
                value:'name',
                type:'textfield'
            },
            {
                text:'Description',
                value:'description',
                type:'textfield'
            }
          ]
      }
  },
  methods:{
    ...mapActions('entities',['entities','getEntities','saveEntity','deleteEntity','approveResponse']),
    ...mapActions('users',['isAdmin'],['isClient'],['isFF']),
    
    reloadData() { 
      this.showTables=false;
      this.getEntities('waybill');
      //this.getEntities('pending_wayBill') 
      var waybills = this.entities['waybill']; 
      if(!this.isFF) this.getEntities('user');
      this.getEntities('ff');
      setTimeout(()=>{
        this.showTables = true
      },250);
    }
  },
  mounted() { 
    this.getEntities('driver');
    this.getEntities('deliveryAddress');
    this.getEntities('truck');
    // this.getEntities('geoRegion')
    
    //this message is received by administrators only
    this.reloadData();
    this.$driverHub.$on('cms_new_waybill', this.reloadData);
    this.hideAddButton = (this.user.roleId===5);
  },
}
</script>